import { render, staticRenderFns } from "./KInputFile.vue?vue&type=template&id=04267226&"
import script from "./KInputFile.vue?vue&type=script&lang=js&"
export * from "./KInputFile.vue?vue&type=script&lang=js&"
import style0 from "./KInputFile.vue?vue&type=style&index=0&id=04267226&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports